import { render } from "./DashboardsCardsWrapper.vue?vue&type=template&id=f2118b4c&scoped=true&ts=true"
import script from "./DashboardsCardsWrapper.vue?vue&type=script&lang=ts"
export * from "./DashboardsCardsWrapper.vue?vue&type=script&lang=ts"

import "./DashboardsCardsWrapper.vue?vue&type=style&index=0&id=f2118b4c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2118b4c"]])

export default __exports__